export const questions = [
  {
    number: 1,
    question: `함께 거주중인 가족 구성원들 모두 반려견을 키우는 것에 동의하시나요?`,
  },
  {
    number: 2,
    question: `함께 거주중인 가족 구성원 중 '털 알레르기'가 있는 사람은 없나요?`,
  },
  {
    number: 3,
    question: `습관 훈련 전까지 반려견의 배변 또는 집안의 물건을 어지르더라도 참을 수 있나요?`,
  },
  {
    number: 4,
    question: `결혼, 이사, 출산 등 생활환경에 큰 변화가 생기더라도 끝까지 책임을 질 수 있나요?`,
  },
  {
    number: 5,
    question: `데려오려는 반려견의 견종에 따른 습성, 걸리기 쉬운 질병들에 대해 공부 하셨나요?`,
  },
  {
    number: 6,
    question: `다른 동물을 키우고 계신다면 동물들 간에 서로 잘 지낼 수 있나요?`,
  },
  {
    number: 7,
    question: `사료, 물품, 병원비 등 반려견 양육에 필요한 지원이 가능한가요?`,
  },
  {
    number: 8,
    question: `장기간 집을 비우는 경우 반려견을 맡길 곳이 있나요?`,
  },
  {
    number: 9,
    question: `자녀가 있다면 함께 책임감 있게 반려견을 돌볼 수 있나요?`,
  },
  {
    number: 10,
    question: `규칙적인 산책을 시켜줄 수 있나요?`,
  },
];
